import { t } from "i18next";

import { Button } from "../../../../components/Button/Button";
import { getObligeeEvidentiraneMarkiceExcelColumns } from "../../../../modules/obligee/usedStamps/usedStamps.constants";
import {
  IskoriscenaAM,
  KategorijaEvidentiraneMarkice,
} from "../../../../modules/obligee/usedStamps/usedStamps.types";
import { writeExcel } from "../../../../utils/writeExcel";

type UsedStampsExcelExportButtonProps = {
  evidentiraneMarkice: IskoriscenaAM[] | null;
  kategorijaEvidentiranihMarkicaId: KategorijaEvidentiraneMarkice;
};

export const UsedStampsExcelExportButton = ({
  evidentiraneMarkice,
  kategorijaEvidentiranihMarkicaId,
}: UsedStampsExcelExportButtonProps) => {
  const hasExportData = Boolean(
    Array.isArray(evidentiraneMarkice) && evidentiraneMarkice?.length
  );

  const handleExportExcel = () => {
    if (!hasExportData) return;

    writeExcel(
      evidentiraneMarkice ?? [],
      getObligeeEvidentiraneMarkiceExcelColumns(
        kategorijaEvidentiranihMarkicaId
      ) as Parameters<typeof writeExcel>[1],
      "lista_evidentiranih_akciznih_markica"
    );
  };

  return (
    <Button
      name="excel-export-obveznik"
      onClick={handleExportExcel}
      disabled={!hasExportData}
    >
      {`${t("COMMON.IZVEZ_U")} Excel`}
    </Button>
  );
};
